const MobilePanelBar = ({ tabs, activeTabId, onSelect }) => (
  <div className="flex lg:hidden gap-1 p-1 rounded-xl bg-inset/40 border border-border shrink-0">
    {tabs.map((tab) => (
      <button
        key={tab.id}
        type="button"
        className={`flex-1 rounded-lg py-1.5 text-xs font-medium transition-colors ${activeTabId === tab.id ? 'bg-accent/20 text-accent' : 'text-textMuted hover:text-white'}`}
        onClick={() => onSelect(tab.id)}>
        {tab.label}
      </button>
    ))}
  </div>
);

export default MobilePanelBar;
